
export const featuredPortfolio = [
    {
      id: 1,
      title: "FACVASS",
      img:
        "assets/featured.jpg",
        link:
        "https://facvassorg.netlify.app/",
    },
  ];
  
 
  export const UIdesign = [
    {
      id: 1,
      title: "Flipkart Clone UI Design",
      img:
        "assets/UIdesign.jpg",
    },
    {
      id: 2,
      title: "Food Ordering Site UI Design",
      img: "assets/UIdesign2.jpg",
    },
    {
      id: 3,
      title: "Gym Site Design",
      img: "assets/UIdesign3.jpg",
    },
    {
      id: 4,
      title: "Time Display UI Design through JavaScript",
      img: "assets/UIdesign4.jpg",
    },
    {
      id: 5,
      title: "Snake Game UI Design made through JavaScript",
      img: "assets/UIdesign5.jpg",
    },
    {
      id: 6,
      title: "Blog Site UI Design",
      img: "assets/UIdesign6.jpg",
    },
  ];
